import React from "react";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";

import "./index.scss";

const termsOfService = (
	<a className="blacklisted-error-link" href="https://okcupid.com/legal/terms" target="_blank" rel="noopener noreferrer">
		<Str>Terms of Service</Str>
	</a>
);

const communityGuidelines = (
	<a className="blacklisted-error-link" href="https://help.okcupid.com/article/142-community-guidelines" target="_blank" rel="noopener noreferrer">
		<Str>Community Guidelines</Str>
	</a>
);

const BlacklistedTerms = () => (
	<div className="blacklisted-error">
		<div><Str>Your account has been banned.</Str></div>
		<Strf
			className="blacklisted-error-text"
			vars={{ termsOfService, communityGuidelines }}
		>
			Please see our $termsOfService and $communityGuidelines for more information.
		</Strf>
	</div>
);

export default BlacklistedTerms;



// WEBPACK FOOTER //
// ./src/apps/login/components/BlacklistedTerms/index.jsx